"use server";

import { revalidatePath } from "next/cache";
import { BOOKS, setActiveBook, type Book } from "@/lib/db";
import { requireOwner } from "@/lib/auth/currentUser";

/** 事業（帳簿）を切り替える。個人事業 ⇄ 法人。全ユーザー共有の状態を変えるためowner専用（統合指示書§8）。 */
export async function switchBookAction(formData: FormData): Promise<void> {
  await requireOwner();
  const book = String(formData.get("book"));
  if ((BOOKS as readonly string[]).includes(book)) {
    setActiveBook(book as Book);
  }
  // 全画面が別DBを参照するため全体を再検証
  revalidatePath("/", "layout");
}
